import {useTranslation} from 'react-i18next';
import {useLocation, useNavigate} from 'react-router-dom';
import {useEffect, useLayoutEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {MODEL_HEADER, TABS_KITCHEN} from '../Model/Models';
import {permissionObj} from '../../../../Helpers/permission';
import HandleChange from '../../../../Helpers/HandleChange';
import {useDailyTrigger} from '../../../../hooks/useDailyTrigger';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const KitchenMainApp = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const [steps, setSteps] = useState([]);
    const [activeStep, setActiveStep] = useState(0);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [isOnline, setIsOnline] = useState(false);
    const [modified, setModified] = useState(false);
    const [simpleSearch, setSimpleSearch] = useState(false); // Simple search flag
    const [item, setItem] = useState({...MODEL_HEADER});
    const [search, setSearch] = useState('');
    const { handleChange } = HandleChange({ model: item, setModel: setItem });
    const [history, setHistory] = useState({...MODEL_HEADER, date: null});
    const { handleChange: onChange } = HandleChange({ model: history, setModel: setHistory });

    /**
     * Permission control in tabs
     */
    useLayoutEffect(() => {
        let activeTab = null;
        const stepConfig = [
            { tab: TABS_KITCHEN.ORDERS.TRANS, perm: [permissionObj?.WEB_KITCHEN_TICKETS_READ], index:TABS_KITCHEN.ORDERS.INDEX },
            { tab: TABS_KITCHEN.HISTORY.TRANS, perm: [permissionObj?.WEB_KITCHEN_TICKETS_HISTORY_READ], index:TABS_KITCHEN.HISTORY.INDEX },
        ];

        const auxStep = stepConfig.reduce((acc, { tab, perm, index }) => {
            const hasPermission = DEV || perm.some(p => permission?.includes(p));
            if (hasPermission) {
                acc.push({label:t(tab), index});
                if(activeTab === null) activeTab = index;
            }
            return acc;
        }, []);

        setSteps(auxStep);

        if(activeTab !== null) handleStepChange(activeTab);
    }, [t, permission]);

    /**
     * Tab change control
     * @param step
     */
    const handleStepChange = (step) => {
        setSearch('')
        setActiveStep(step);
    };

    /**
     * set the values of the history tab
     */
    useEffect(() => {
        setModified(false);
        if(activeStep == 0){
            setHistory({...MODEL_HEADER, date: null});
        }
    }, [activeStep]);

    /**
     * Set the value of setIsReload
     */
    useEffect(() => {
        if(isOnline){
            setModified(false);
        }
    }, [isOnline]);

    useEffect(() => {
        if(activeStep == TABS_KITCHEN.HISTORY.INDEX){
            setIsOnline(false);
        }
    }, [activeStep]);


    useDailyTrigger({setItem});

    return {
        t,
        navigate,
        location,
        DEV,
        permission,
        steps,
        activeStep,
        setActiveStep,
        handleStepChange,
        handleChange,
        item,
        search,
        setSearch,
        isOnline, setIsOnline,
        modified, setModified,
        history, setHistory,
        onChange,
        simpleSearch, setSimpleSearch
    }

}

export default KitchenMainApp;
